import { createClient } from "@supabase/supabase-js";
import { syncReviewId } from "./driveSync/reviewScope";
import { AUTH_RELEASED, CLOUD_ACCOUNT_RELEASED } from "./features";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
export const supabaseConfigured = Boolean(url && key);
// Demo and the legacy /local route stay completely isolated from authentication.
// Free Trial uses Supabase only for the teacher identity; its classroom data still
// lives in the browser's local SQLite store.
const currentPath = typeof location === "undefined" ? "" : location.pathname;
const isolatedPreviewRoute = ["/local", "/demo"].some(
  (prefix) => currentPath === prefix || currentPath.startsWith(`${prefix}/`),
);
const betaAuthRoute = currentPath === "/app" || currentPath.startsWith("/app/") || Boolean(syncReviewId());
const clientEnabled = !isolatedPreviewRoute && (CLOUD_ACCOUNT_RELEASED || (AUTH_RELEASED && betaAuthRoute));
export const supabase =
  clientEnabled && supabaseConfigured
    ? createClient(url!, key!, {
        auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true },
      })
    : undefined;

export async function backend<T>(action: string, payload: Record<string, unknown>): Promise<T> {
  if (!supabase || !url || !key) throw new Error("尚未設定 Supabase。");
  const { data: session } = await supabase.auth.getSession();
  if (!session.session) throw new Error("請先登入。");
  const response = await fetch(`${url}/functions/v1/backend`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: key,
      Authorization: `Bearer ${session.session.access_token}`,
    },
    body: JSON.stringify({ action, ...payload }),
  });
  const result = (await response.json()) as T & { error?: string };
  if (!response.ok) throw new Error(result.error || "要求未能完成。");
  return result;
}
